import TYPES from './_types';

export default {
  [TYPES.UPDATE_FORM](state, data) {
    state.formInfo = Object.assign({}, state.form, {
      ...data.data
    });
    state.originData = data.resData;
  },
  [TYPES.UPDATE_ACTIVE_CODE](state, data) {
    state.activeCode = data;
  },
  [TYPES.UPDATA_EXIST_ACTIVE_CODE](state, data) {
    state.existActiveCode = data;
  },
  [TYPES.UPDATE_NO_REPORT_CODE](state, data) {
    state.noReportCode = data;
  },
  [TYPES.UPDATE_SHOW_LOCATION](state, data) {
    state.showLocation = data;
  },
  [TYPES.UPDATE_LOCATION_STREET](state, data) {
    state.locationStreet = data;
  },
  [TYPES.UPDATE_COMPANY_SEARCH](state, data) {
    state.showCompanySearch = data;
  },
  [TYPES.UPDATE_QUERY_ACTIVE_CODE](state, data) {
    state.alreadyActivated = data;
  },
  [TYPES.CLEAR_DATA](state, data) {
    state.formInfo.dealer = '';
    state.formInfo.company = '';
    state.formInfo.contactPerson = '';
    state.formInfo.telephone = '';
    state.formInfo.districtArr = [];
    state.formInfo.street = '';
    state.locationStreet = '';
  },
  [TYPES.UPDATE_ADDRESS](state, data) {
    state.address.province = data.province;
    state.address.city = data.city;
    state.address.district = data.district;
  }
};



// WEBPACK FOOTER //
// ./src/stores/form/_mutations.js